import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/features/utils';
import { JlifeCallback } from 'api/general/models';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory<JlifeCallback>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const jlifeCallbackReducer = createReducer<State, Actions>(initialState, {
  [actions.jlifeCallback.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.jlifeCallback.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.jlifeCallback.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.jlifeCallback.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default jlifeCallbackReducer;
